import { CategoryType } from 'src/graphql';

export const getCategoryTogglesChanged = (
  category: CategoryType,
  currentCategory: CategoryType | null,
): boolean => {
  const isCurrentCategory =
    currentCategory && category.id === currentCategory.id;
  if (!currentCategory || !isCurrentCategory) {
    return false;
  }
  const allowGoTogetherChanged =
    category.allowGoTogether !== currentCategory.allowGoTogether;
  const displayInAppChanged =
    category.displayInApp !== currentCategory.displayInApp;
  const displayInManualIntakeChanged =
    category.displayInManualIntake !== currentCategory.displayInManualIntake;
  const displayInOpenReportingChanged =
    category.displayInOpenReporting !== currentCategory.displayInOpenReporting;
  const displayInVaultTalkChanged =
    category.displayInVaultTalk !== currentCategory.displayInVaultTalk;
  const displayInCollaborationToolIntegration =
    category.displayInCollaborationToolIntegration !==
    currentCategory.displayInCollaborationToolIntegration;
  const isDeterminedCategoryChanged =
    category.isDeterminedCategory !== currentCategory.isDeterminedCategory;
  const isReportedCategoryChanged =
    category.isReportedCategory !== currentCategory.isReportedCategory;
  const questionChanged = category.question !== currentCategory.question;
  const isCustomQuestionsChanged =
    Boolean(category.isCustomQuestions) !==
    Boolean(currentCategory.isCustomQuestions);

  return (
    allowGoTogetherChanged ||
    displayInAppChanged ||
    displayInManualIntakeChanged ||
    displayInOpenReportingChanged ||
    displayInVaultTalkChanged ||
    displayInCollaborationToolIntegration ||
    isDeterminedCategoryChanged ||
    isReportedCategoryChanged ||
    questionChanged ||
    isCustomQuestionsChanged
  );
};
